<template>
  <div>
    <BaseLoading v-if="isMatchAthletesPerformanceLoading" />
    <template v-else-if="athletesPerformance.length">
      <TheAthleteGoalsOverviewCard
        v-for="performance in athletesPerformance"
        :id="performance.athlete.id"
        :key="performance.id"
        :name="performance.athlete.name"
        :avatar="performance.athlete.image"
        :time="performance.time"
        :team="performance.athlete.team"
        :category="performance.category.name"
        :value="performance.value"
        :is-selected="isAthleteSelected({ athleteId: performance.athlete.id })"
      />
    </template>
    <BaseAlert
      v-else
      is-center
      variant="light"
    >
      {{ $t('nobody-has-scored-in-this-match-yet') }}
    </BaseAlert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseLoading from '@/components/Atoms/BaseLoading'
import TheAthleteGoalsOverviewCard from '@/components/Molecules/TheAthleteGoalsOverviewCard'
import BaseAlert from '@/components/Atoms/BaseAlert'

export default {
  components: {
    BaseAlert,
    TheAthleteGoalsOverviewCard,
    BaseLoading,
  },
  data() {
    return {
      matchId: `${this.$route.params.league}/${this.$route.params.match}`,
    }
  },
  computed: {
    ...mapState({
      isMatchAthletesPerformanceLoading: state => state['matches/matchAthletePerformance'].isMatchAthletesPerformanceLoading,
    }),
    athletesPerformance() {
      return this.$store.getters['matches/matchAthletePerformance/getMatchAthletesPerformance'](this.matchId)
    },
    roundAthletes() {
      return this.$store.getters['rounds/athletesInRound/getSelectedAthletesForRound']()
    },
  },
  methods: {
    isAthleteSelected({ athleteId }) {
      return !!Object.values(this.roundAthletes).find(({ id }) => {
        return athleteId === id
      })
    },
  },
}
</script>

<style scoped>

</style>
